import { render, staticRenderFns } from "./UeSubcriberChart.vue?vue&type=template&id=f548e14e&scoped=true&"
import script from "./UeSubcriberChart.vue?vue&type=script&lang=js&"
export * from "./UeSubcriberChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548e14e",
  null
  
)

export default component.exports